// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__24-sR","item":"Report_item__jsPOg","placeHolderShimmer":"Report_placeHolderShimmer__DPR8n"};